// extracted by mini-css-extract-plugin
export default {"Img":"Logo_Img__49FEL"};